import { combineReducers } from 'redux';
import axios from 'axios';
import { startSubmit, stopSubmit } from 'redux-form';

import createNamedWrapperReducer from 'src/reducers/createNamedWrapperReducer';
import { listReducer, itemReducer } from 'src/reducers/common';
import { setGlobalErrors, setGlobalSuccesses } from 'src/reducers/global';

import { CUSTOM_FEATURE_FORM } from 'src/constants/FormNames';
import { CLIENT_CUSTOM_FEATURE_UPDATE, CLIENT_CUSTOM_FEATURE_SETTING } from 'src/constants/EndpointUrls';

import { concatParamsToUrl, redirectTo } from 'src/utils/Http';

export const REDUCER_NAME = 'customFeature';

export const createCustomFeature = (data) => async (dispatch) => {
  try {
    dispatch(startSubmit(CUSTOM_FEATURE_FORM));
    const update = {
      clientId: data.clientId,
      clientCustomFeature: {
        featureType: data.featureType,
        status: 'using',
        option: data.option,
        condition: data.condition,
        value: data.value,
      },
    };

    const createUrl = concatParamsToUrl(CLIENT_CUSTOM_FEATURE_UPDATE, { client_id: data.clientId });

    const response = await axios.put(createUrl, { update });

    if (response.status === 200) {
      dispatch(stopSubmit(CUSTOM_FEATURE_FORM));
      dispatch(setGlobalSuccesses(response.data.message));

      setTimeout(() => {
        redirectTo(concatParamsToUrl(CLIENT_CUSTOM_FEATURE_SETTING, { client_id: data.clientId }));
      } , 1000 );
    }
  } catch (error) {
    dispatch(stopSubmit(CUSTOM_FEATURE_FORM));
    dispatch(setGlobalErrors(error.response.data.errors.messages));
  }
};

export const updateCustomFeature = (data) => async (dispatch) => {
  try {
    dispatch(startSubmit(CUSTOM_FEATURE_FORM));
    const update = {
      clientId: data.clientId,
      clientCustomFeature: (({ clientId, ...o }) => o)(data),
    };
    const updateUrl = concatParamsToUrl(CLIENT_CUSTOM_FEATURE_UPDATE, { client_id: data.clientId });

    const response = await axios.put(updateUrl, { update });

    if (response.status === 200) {
      dispatch(stopSubmit(CUSTOM_FEATURE_FORM));
      dispatch(setGlobalSuccesses(response.data.message));

      setTimeout(() => {
        redirectTo(concatParamsToUrl(CLIENT_CUSTOM_FEATURE_SETTING, { client_id: data.clientId }));
      } , 1000 );
    }

  } catch (error) {
    dispatch(stopSubmit(CUSTOM_FEATURE_FORM));
    dispatch(setGlobalErrors(error.response.data.errors.messages));
  }
};

export default combineReducers({
  list: createNamedWrapperReducer(listReducer, REDUCER_NAME),
  item: createNamedWrapperReducer(itemReducer, REDUCER_NAME),
});
